import { useNavigate } from "react-router-dom";
import emailIcon from "../../assets/email.png";
import AuthStatusPage from "./AuthStatusPage";

function ConfirmationOverlay({ email, onResendClick }) {
  const navigate = useNavigate();

  const navigateToLogin = () => {
    navigate("/login");
  };

  return (
    <AuthStatusPage
      pageTitle="Check Email | EMAlpha"
      topBarPrompt="Already confirmed?"
      topBarCtaLabel="Log in"
      topBarCtaTo="/login"
      icon={emailIcon}
      iconAlt="Email"
      eyebrow="Confirmation"
      title="Check your inbox"
      description="We sent a confirmation link to your email address. Open it to finish setting up your account."
      primaryAction={{ label: "Back to log in", onClick: navigateToLogin }}
      secondaryAction={
        onResendClick ? { label: "Resend email", onClick: onResendClick } : null
      }
    >
      {email ? (
        <p className="auth-status__meta">
          Confirmation email sent to <strong>{email}</strong>
        </p>
      ) : null}
    </AuthStatusPage>
  );
}

export default ConfirmationOverlay;
